'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _trackClick = require('../HOCs/trackClick');

var _listingsModule = require('../listings/listingsModule');

var ListingsActions = _interopRequireWildcard(_listingsModule);

var _AnalyticsModule = require('../analytics/modules/AnalyticsModule');

var _SearchBar = require('./SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _CategoryMenu = require('./CategoryMenu');

var _CategoryMenu2 = _interopRequireDefault(_CategoryMenu);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/Header.css') : void 0;

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var search = _ref.search,
      setSearch = _ref.setSearch,
      setSearchAndFilter = _ref.setSearchAndFilter,
      setCategory = _ref.setCategory,
      clearSearch = _ref.clearSearch,
      category = _ref.category,
      categories = _ref.categories,
      setAndFilterByCategory = _ref.setAndFilterByCategory,
      enableLiveSearch = _ref.enableLiveSearch,
      filterApps = _ref.filterApps,
      router = _ref.router,
      location = _ref.location,
      host = _ref.host,
      listingId = _ref.listingId,
      listings = _ref.listings,
      companyUUID = _ref.companyUUID,
      userId = _ref.userId,
      trackCategoryLinkClick = _ref.trackCategoryLinkClick;

  var handleHeaderClick = function handleHeaderClick() {
    if (router.location.pathname !== (0, _utils.getAppCenterPathName)(location.pathname)) {
      setCategory();
    }
    clearSearch();
    setSearch();
    setCategory();
    router.push((0, _utils.getAppCenterPathName)(location.pathname));
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-7 col-xs-12' },
        _react2.default.createElement(
          _trackClick.Tracked,
          {
            event: 'CLICK',
            additional: {
              context: router.location.pathname === (0, _utils.getAppCenterPathName)(location.pathname) ? 'HOME' : 'LISTING_DETAILS',
              type: 'LINK',
              value: 'APPCENTER_HEADER',
              domain: { host: host }
            }
          },
          _react2.default.createElement(
            'h2',
            {
              className: 'appcenter-title',
              onClick: handleHeaderClick
            },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'AppCenterHeader' })
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'col-xs-5 col-sm-5 col-xs-12' },
        _react2.default.createElement(_SearchBar2.default, {
          search: search,
          onChange: enableLiveSearch ? setSearchAndFilter : setSearch,
          filterApps: filterApps
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-sm-4' },
        _react2.default.createElement(_CategoryMenu2.default, {
          display: !listingId && listings.length >= 20,
          category: category,
          categories: categories,
          companyUUID: companyUUID,
          userId: userId,
          setAndFilterByCategory: setAndFilterByCategory,
          trackCategoryLinkClick: trackCategoryLinkClick
        })
      )
    )
  );
};

Header.propTypes = {
  search: _propTypes2.default.string.isRequired,
  setSearch: _propTypes2.default.func,
  setSearchAndFilter: _propTypes2.default.func.isRequired,
  setCategory: _propTypes2.default.func.isRequired,
  clearSearch: _propTypes2.default.func.isRequired,
  filterApps: _propTypes2.default.func.isRequired,
  setAndFilterByCategory: _propTypes2.default.func.isRequired,
  categories: _propTypes2.default.arrayOf(_propTypes2.default.object),
  enableLiveSearch: _propTypes2.default.bool,
  location: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  router: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
  host: _propTypes2.default.string,
  trackCategoryLinkClick: _propTypes2.default.func,
  companyUUID: _propTypes2.default.string,
  userId: _propTypes2.default.string
};

function mapStateToProps(state) {
  return {
    listings: state.listings.list,
    search: state.listings.search,
    categories: state.listings.categories,
    category: state.listings.category,
    host: state.meta.host,
    companyUUID: state.userPrefs.companyUUID,
    userId: state.userPrefs.userId
  };
}

var mappedHeader = (0, _reactRedux.connect)(mapStateToProps, {
  setSearch: ListingsActions.setSearch,
  setCategory: ListingsActions.setCategory,
  clearSearch: ListingsActions.clearSearch,
  setSearchAndFilter: ListingsActions.setAndFilter,
  filterApps: ListingsActions.filterListingsByAll,
  setAndFilterByCategory: ListingsActions.setAndFilterByCategory,
  trackCategoryLinkClick: _AnalyticsModule.linkClickDispatch
})(Header);

exports.default = (0, _reactRouter.withRouter)(mappedHeader);


//////////////////
// WEBPACK FOOTER
// ./lib/shared/Header.js
// module id = 137
// module chunks = 0